module.exports = __webpack_public_path__ + "static/JQuery-Logo-904d08085b46ecbf4802a94c5daed736.svg";